import { Row, Form, Button } from 'react-bootstrap'; // Importing Row component from react-bootstrap
import { reducerActions } from '../Reducers/FormReducer';
import Col from './Col2.js';

const ButtonControls = ({ state, dispatchState }) => {
 
    const resetForm = () => {
       dispatchState({ type: reducerActions.RESET_FORM }); 
    }
    
    return (
         <Row className="buttons">
        <Col className="col2-12">

         <Button id= {`previous-button`}
                className={`previous-button ${state.firstPage === state.activePage || state.numberOfPages < 2 ? 'hidden':''}`}
                onClick={() => {
                  dispatchState({ type: reducerActions.GO_TO_PREVIOUS_PAGE, payload: null });
                }}>
                  Previous Page
              </Button> 
              
              <Button id= {`next-button`}
                className={`next-button  ${state.lastPage === state.activePage || state.numberOfPages < 2 ? 'hidden':''}`}
                onClick={() => {
                    dispatchState({ type: reducerActions.GO_TO_NEXT_PAGE, payload: null });
                }}>                
                  Next Page
              </Button>

            <Button 
                id= {`submit-button`}  
                className = {`${state.numberOfPages < 2 || state.activePage === state.lastPage ? 'submit-button':'hidden'}`}
                onClick ={() => {
                    dispatchState({ type: reducerActions.SUBMIT_FORM, payload: null });
                }}
            >
                {state.formObject.submitText || "Submit"}
            </Button>         
          
            
          {state.formState.showResetButton && (
            <Button onClick = {()=>resetForm()} 
              variant = "secondary" 
              type = "reset" 
              className = "ml-2">
              Reset
            </Button>           
          )}

           {state.formState.showSavePdfOption && state.activePage === state.lastPage && (
           <Form.Check // prettier-ignore   
            className="saveCopyCheckbox"
            type="checkbox"      
            id={`saveCopyCheckbox`}
            value = {state.formState.saveCopy}
            onChange={(e) => {
              dispatchState({ type: reducerActions.SET_SAVE_COPY, payload: e.target.checked });              
            }}            
            label={state.formObject.savePdfOptionLabel || "Save a PDF copy"}
          />
        )}
        </Col>
      </Row>
    );
};
export default ButtonControls;